/**
 * BentoCard — a card tile for the bento grid (DS core). Rounded surface with an
 * optional centred title, a `light` (bg-subtle) or `dark` (statement) variant,
 * and free content below. Content-agnostic. Place spans via `className`
 * (e.g. `lg:col-span-2`, `lg:row-span-2`) from the composing grid.
 */
import type { ReactNode } from "react";
import { CardHeading } from "./Heading";

export function BentoCard({
  title,
  dark = false,
  center = false,
  className = "",
  children,
}: {
  title?: ReactNode;
  dark?: boolean;
  /** Centre the title (default left-aligned). */
  center?: boolean;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <div
      className={`group relative flex h-full flex-col overflow-hidden rounded-3xl border-8 border-white p-4 md:p-7 font-ds shadow-[0_1px_3px_rgba(15,23,42,0.05)] ${
        dark ? "bg-ds-surface-dark text-white" : "bg-bg-subtle text-ds-ink"
      } ${className}`}
    >
      {title && <CardHeading title={title} tone={dark ? "dark" : "light"} align={center ? "center" : "start"} />}
      {children}
    </div>
  );
}
